module.exports = __webpack_public_path__ + "static/media/thumb.026cb7c6.jpg";